// extracted by mini-css-extract-plugin
export default {"SuggestedVideos":"SuggestedVideos_SuggestedVideos__SeFI0","Video":"SuggestedVideos_Video__rTvUm","Title":"SuggestedVideos_Title__wwArG","Channel":"SuggestedVideos_Channel__J6PmJ"};